import { PeriformInputsReportOptions } from './perifor-inputs-report-options.model';
import { PericalReportOptions } from './perical-report-options.model';
import { PerivisReportOptions } from './perivis-report-options.model';

/**
 * Stored in saved options — just the section on/off toggles.
 * Sub-report options (Perical Results, Perivis Results, etc.) are saved
 * separately under their own keys and assembled at download time.
 */
export interface CombinedReportSectionToggles {
  includePeriforInputs: boolean;
  includePericalOpSummary: boolean;
  includePerivisLoadCaseSummary: boolean;
  includePericalResults: boolean;
  includePerivisResults: boolean;
}

/**
 * Full POST body sent to POST /api/reports/combined-report.
 * Assembled at download time from saved toggles + saved sub-report options.
 */
export interface CombinedReportOptions {
  includePeriforInputs: boolean;
  periforInputsOptions: PeriformInputsReportOptions;
  includePericalOpSummary: boolean;
  includePerivisLoadCaseSummary: boolean;
  includePericalResults: boolean;
  pericalResultsOptions: PericalReportOptions | null;
  includePerivisResults: boolean;
  perivisResultsOptions: PerivisReportOptions | null;
}

export class CombinedReportDefaults {
  /** All sections enabled — used when no setup has been saved yet. */
  static readonly SectionToggles: CombinedReportSectionToggles = {
    includePeriforInputs: true,
    includePericalOpSummary: true,
    includePerivisLoadCaseSummary: true,
    includePericalResults: true,
    includePerivisResults: true,
  };
}
